export default {
  // categoryFilters: {},
  fetching: false,
  error: null,
  dataList: {
    metadata: {
      stats: []
    },
    data: [],
    links: {},
    meta: {
      total: ''
    }
  },
  originalData: [],
  fetchingDocumentDetail: false,
  documentDetail: [],
  detailPageMun: null,
  documentTypes: {
    gov: [],
    laws: [],
    surveys: [],
    research: []
  }
};



// WEBPACK FOOTER //
// ./src/datahub/initialState.js